import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-other2-icon',
  templateUrl: './general-other2.component.html'
})
export class GeneralOther2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
